import React from 'react';

const SectionTitle = ({ title }) => {
  return (
    <div className="text-center mb-4">
      <h2 className="d-inline-block position-relative pb-2 mb-0">
        {title.toUpperCase()}
        <span className="position-absolute start-0 bottom-0 w-100" 
              style={{ 
                height: '2px',
                background: '#d4af37',
                display: 'block'
              }}>
        </span>
      </h2>
    </div>
  );
};

export default SectionTitle; 